import { useFormik } from "formik";
import { NumericFormat } from "react-number-format";
import * as Yup from "yup";
import {
  getCurrencySymbol,
  parseStringToNumber,
} from "../../../../../helperFunctions";
import { useGetVerificationTokenMutation } from "../../../../../redux/features/auth/auth.api";
import { Button } from "../../../../buttons/button";
import { TextInput } from "../../../../inputs/textInput";

export const StepTwo = ({
  onSuccess,
}: {
  onSuccess: (amount: number) => void;
}) => {
  const [getToken, { isLoading: gettingToken }] =
    useGetVerificationTokenMutation();

  const { handleBlur, touched, errors, values, handleSubmit, handleChange } =
    useFormik({
      initialValues: {
        amount: "",
      },
      validationSchema: Yup.object().shape({
        amount: Yup.string()
          .required("Amount is required")
          .test(
            "is-above-minimum",
            `Amount must be greater than 0`,
            (value) => {
              return (parseStringToNumber(value) ?? 0) > 0;
            }
          ),
      }),
      onSubmit: async (values) => {
        const resp = await getToken();

        if (resp.data?.success) {
          onSuccess(parseStringToNumber(values.amount)!);
        }
      },
    });

  return (
    <form
      onSubmit={handleSubmit}
      className="flex-1 flex flex-col justify-between"
    >
      <NumericFormat
        suffix={undefined}
        prefix={getCurrencySymbol("NGN")}
        decimalScale={2}
        thousandSeparator
        allowLeadingZeros={false}
        customInput={TextInput}
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        name="amount"
        value={values?.amount ?? ""}
        placeholder={`Enter amount`}
        hasIcon={false}
        autoComplete="off"
        errors={touched?.amount && errors?.amount ? errors?.amount : ""}
        className="!mt-4"
      />

      <Button
        type="submit"
        className=""
        text="Proceed"
        loading={gettingToken}
        disabled={gettingToken}
      />
    </form>
  );
};
